<template>
  <div>
    <input-post
      hasActionButton
      rich
      :editFields="getAdvertisable"
      :type="getPostType"
      ref="postInput"
      @fieldUpdate="fieldUpdate"
      @updateValidity="updateValidity" />

    <!-- Input's own action buttons(s)-->
    <div
      id="postUpdate"
      class="text-center mt-3">

      <input-button
        centered
        :inputPlaceholder="$t('Button.update')"
        @click="updateAdvertisable"
        variant="standardInput"
        :dissabled="!fieldsValid"
        btnStyle="ok-style" />

      <b-tooltip 
        v-if="!fieldsValid" 
        target="postUpdate" 
        container="postUpdate"
        :title="$t('Post.warning')"/>

    </div>
  </div>
</template>

<script>
import InputPost from '@/components/standard/input/InputPost'
import InputButton from '@/components/standard/input/InputButton'

import apiConnector from '@/mixins/apiConnector'
import quickPostEditor from '@/mixins/pagination/providers/quickPostEditor'

import manager from '@/assets/modules/notifications/manager'
import resolver from '@/assets/modules/error/resolver'

import fieldBuilder from '@/assets/modules/apollo/fieldBuilder'

export default {
  data () {
    return {
      gqlObject: {},
      fieldsValid: false,
      advertisables: {}
    }
  },
  methods: {
    /**
     * Updates input's validity
     * @param {Object} e
     */
    updateValidity (e) {
      this.fieldsValid = e.valid
    },

    /**
     * Updates changes
     * @param {Object} e
     */
    fieldUpdate (e) {
      this.$set(this, 'gqlObject', e.gqlObject)
    },

    /**
     * Updates the advertisable it received from InputPost
     * @param {Object} e InputPost object
     */
    updateAdvertisable (e) {
      let { gqlObject } = this

      let okCallback = (data) => {
        this.$refs.postInput.setClearCallback(this.completeUpdate)
        this.$refs.postInput.processImages('advertisable', data.id)
      }

      if (!this.hasUpdated) {
        this.completeUpdate()
        return
      }

      let failCallback = (_, e) => {
        let message = 'Advertisable failed to be created!'
        message = resolver.resolve(e.message)
        manager.nokNotification(this, message)
      }

      let {mutationString, dataObject, name} = fieldBuilder
        .buildGqlObject(gqlObject, 'storeAdvertisable', 'mutation', [], {
          type: 'AdvertisableType',
          product: 'AdvertisableProductInput',
          post: 'AdvertisablePostInput',
          importedProduct: 'AdvertisableImportedProductInput'
        })

      this.sendMutation(
        mutationString,
        dataObject,
        okCallback,
        failCallback,
        name)
    },

    /**
     * Completes advertisable update
     */
    completeUpdate () {
      manager.okNotification(this, 'Notification.ok.contentUpdated.label')
      this.$router.push({name: 'AdvertisableManager'})
    }
  },

  computed: {
    /**
     * Tells if user has done any adjustments
     * @returns {Booelan}
     */
    hasUpdated () {
      return !!Object.keys(this.gqlObject).length
    },

    /**
     * Gives edited advertisable's id
     * Required by quickPostEditor mixin!
     * @returns {String}
     */
    getAdvertisableId () {
      return this.$route.params.postId
    },
    
    /**
     * Gives post's type
     * @returns {String}
     */
    getPostType () {
      return this.getAdvertisable.postsType
    },
  },

  mixins: [
    apiConnector,
    quickPostEditor
  ],

  components: {
    'input-button': InputButton,
    'input-post': InputPost
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/service/postManager/PostEditor.vue?61196390